<template>
  <div class="home">
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('PackageDetail.title')"
      left-arrow
      fixed
      :z-index="9"
      @click-left="$router.push('/E_Dishes')"
    >
    </van-nav-bar>
    <div v-if="detail" style="padding-top:46px">
      <div class="dish_content">
        <van-image
          v-if="detail.image"
          width="130px"
          height="130px"
          @click="ImagePreviewBtn(detail.image.path)"
          :src="detail.image.path"
        />
        <van-image v-else width="130px" height="130px" src="" />
        <div class="info">
          <div
            class="noExceed"
            style="height: 30px;font-size: 16px;line-height: 30px;"
          >
            {{ detail.name }}
          </div>
          <div class="noExceed" style="font-size: 16px;line-height:16px;">
            {{ detail.name_en }}
          </div>
          <div class="dish_footer">
            <van-rate
              style="height: 16px;"
              v-model="detail.level"
              readonly
              :size="16"
              gutter="3px"
              icon="./static/img/Recommend-s.png"
              void-icon="./static/img/Recommend.png"
            />
            <div class="fontLine">
              <span class="currentPrice"
                >{{ sessionStorage.getItem("currency") }}
                {{
                  detail.type == "o"
                    ? detail.original_price
                    : detail.special_price
                }}</span
              >&nbsp;&nbsp;&nbsp;<span
                class="oldPrice"
                v-show="detail.type == 's'"
                >{{ sessionStorage.getItem("currency")
                }}{{ detail.original_price }}</span
              >
            </div>
          </div>
          <p
            style="font-size: 14px;color: #666;padding: 0;margin-bottom: 10px;margin-top: 10px;word-break: break-all;"
          >
            {{ detail.introduction }}
          </p>
        </div>
      </div>
      <div style="height: 3px;width: 100%;background-color: #F3F5F7;"></div>
      <div class="dishList" v-if="detail.tags && detail.tags.data">
        <template v-for="(tag, index) in detail.tags.data">
          <div class="dishItem" v-if="tag.menus.length > 0" :key="index">
            <div
              style="height: 3px;width: 100%;background-color: #F3F5F7;"
            ></div>
            <div class="dishTitle noExceed">
              {{ tag.name }}
            </div>
            <div
              class="dishChild"
              v-for="(menu, key) in tag.menus"
              :key="`menu${key}`"
            >
              <div
                class="dishChild_content"
                :style="
                  typeof checkMenuIndex[index] == 'object'
                    ? checkMenuIndex[index].indexOf(key) != -1
                      ? {
                          border: `2px solid ${sessionStorage.colorCode}`,
                          background: sessionStorage.colorCode,
                          color: '#fff'
                        }
                      : { border: `2px solid ${sessionStorage.colorCode}` }
                    : checkMenuIndex[index] == key
                    ? {
                        border: `2px solid ${sessionStorage.colorCode}`,
                        background: sessionStorage.colorCode,
                        color: '#fff'
                      }
                    : { border: `2px solid ${sessionStorage.colorCode}` }
                "
              >
                <template v-if="tag.is_choiced == 1">
                  <van-image
                    v-if="menu.image"
                    class="noflex"
                    :style="{ border: `2px solid ${sessionStorage.colorCode}` }"
                    width="40"
                    height="40"
                    :src="menu.image.path"
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  />
                  <van-image
                    v-else
                    class="noflex"
                    :style="{ border: `2px solid ${sessionStorage.colorCode}` }"
                    width="40"
                    height="40"
                    src=""
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  />
                </template>
                <template v-else>
                  <van-image
                    v-if="menu.image"
                    class="noflex"
                    :class="[
                      checkMenuIndex[index] == key ? 'actChild' : 'childImg'
                    ]"
                    :style="{ border: `2px solid ${sessionStorage.colorCode}` }"
                    width="40"
                    height="40"
                    :src="menu.image.path"
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  />
                  <van-image
                    v-else
                    class="noflex"
                    :class="[
                      checkMenuIndex[index] == key ? 'actChild' : 'childImg'
                    ]"
                    :style="{ border: `2px solid ${sessionStorage.colorCode}` }"
                    width="40"
                    height="40"
                    src=""
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  />
                </template>

                <div class="childTitle">
                  <div
                    class="childTitle1 noExceed"
                    @click="changeChildDish(index, menu.target_id, key, 0)"
                  >
                    {{ menu.name }}
                  </div>
                </div>
                <div style="float: right;margin-right:5px">
                  {{ sessionStorage.getItem("currency") }}{{ menu.fill_price }}
                </div>
              </div>
              <template>
                <div class="fr" @click="showTaste(index, key)">
                  <img
                    src="../../static/img/notes.png"
                    :style="{
                      width: '30px',
                      height: '30px',
                      border: `2px solid ${sessionStorage.colorCode}`,
                      borderRadius: '10px',
                      padding: '5px'
                    }"
                  />
                </div>
              </template>
              <!-- <template v-else>
                <div class="tasteBtn fr" style="opacity: 0;">
                  <img
                    src="../../static/img/Option.png"
                    style="width:50px;height:32px"
                  />
                </div>
              </template> -->
              <!-- <template v-if="tag.is_choiced == 1">
                <van-icon
                  class="selChild"
                  v-if="checkMenuIndex[index].indexOf(key) != -1"
                  name="./static/img/sele_food.png"
                  size="18px"
                />
              </template>
              <template v-else>
                <van-icon
                  class="selChild"
                  v-if="checkMenuIndex[index] == key"
                  name="./static/img/sele_food.png"
                  size="18px"
                />
              </template> -->
            </div>
          </div>
        </template>
      </div>
    </div>
    <div style="height: 50px;background: #F3F5F7;"></div>
    <van-popup
      v-model="isTasteShow"
      position="bottom"
      :style="{ height: '75%' }"
    >
      <van-cell-group>
        <van-cell>
          <div style="font-size: 16px;" slot="title">
            {{ $t("PackageDetail.note") }}
          </div>
          <van-icon
            slot="right-icon"
            name="./static/img/dele_staff.png"
            size="26px"
            @click="isTasteShow = false"
          />
        </van-cell>
      </van-cell-group>
      <div v-if="actPerfer" class="tasteGropu">
        <template v-for="(item, index) in actPerfer">
          <div
            class="tasteItem"
            v-if="item.category.data.length > 0"
            :key="index"
          >
            <div class="tasteItemTitle">{{ item.name }}</div>
            <span
              class="is_choiced tagsBox"
              v-if="actPerfer[index].is_choiced == 1"
            >
              <div
                v-for="(val, key) in item.category.data"
                :key="key"
                class="tasteItemRadio"
                :style="[
                  childResult[index][key] == val.id
                    ? {
                        background: sessionStorage.colorCode,
                        border: `1px solid ${sessionStorage.colorCode}`,
                        color: '#ffffff'
                      }
                    : { border: `1px solid ${sessionStorage.colorCode}` }
                ]"
                @click="changeResult(index, key, val.id)"
              >
                {{ val.name }}
                <span v-if="val.price != 0"
                  >{{ sessionStorage.getItem("currency") }}
                  {{ val.price }}</span
                >
              </div>
            </span>
            <span class="tagsBox" v-else>
              <div
                v-for="(val, key) in item.category.data"
                :key="key"
                class="tasteItemRadio"
                :style="[
                  childResult[index][0] == val.id
                    ? {
                        background: sessionStorage.colorCode,
                        border: `1px solid ${sessionStorage.colorCode}`,
                        color: '#ffffff'
                      }
                    : { border: `1px solid ${sessionStorage.colorCode}` }
                ]"
                @click="changeResult(index, key, val.id)"
              >
                {{ val.name }}
                <span v-if="val.price != 0"
                  >{{ sessionStorage.getItem("currency") }}
                  {{ val.price }}</span
                >
              </div>
            </span>
          </div>
        </template>
        <div class="tasteItem">
          <div class="tasteItemTitle">{{ $t("PackageDetail.remark") }}</div>
          <van-field
            :style="{ border: `1px solid ${sessionStorage.colorCode}` }"
            v-model="actRemark"
            rows="3"
            autosize
            type="textarea"
            maxlength="80"
            :placeholder="$t('PackageDetail.inputRemark')"
            show-word-limit
            style="text-indent: 10px;border:1px solid #2f75f4;border-radius: 5px;"
          />
        </div>
      </div>
      <!-- <div style="width: 100%;height: 50px;">
        <van-button
          :style="{ background: sessionStorage.colorCode }"
          style="width: 90%;height: 35px;margin-left: 5%;margin-top: 7px;line-height: 35px;"
          round
          @click="saveChange()"
          >{{ $t("PackageDetail.certain") }}</van-button
        >
      </div> -->
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
      isTasteShow: false,
      actPerfer: [],
      actRemark: "",
      menus_id: [],
      checkMenuIndex: [],
      tags_id: [],
      fill_price: [],
      remarks: [],
      perferResult: [],
      childResult: [],
      actIndex: "",
      //购物车数据
      isShopCartShow: false,
      shopCart: {},
      //动效 声音
      visible: false,
      bottomNum: 33,
      leftNum: 50,
      musicPlayer: new Audio()
    };
  },
  mounted: function() {
    this.getPackageDetail();
  },
  methods: {
    // 图片预览
    ImagePreviewBtn(imgUrl) {
      if (imgUrl) {
        this.ImagePreview([`${imgUrl}`]);
      }
    },
    getPackageDetail() {
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build + "/api/menu/" + this.$route.params.id + "/customerIndex"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.detail = res.data.data;
            for (var i = 0; i < this.detail.tags.data.length; i++) {
              var temp = {};
              temp.key = i;
              temp.id = "";
              var perfer = [];
              var price = 0;
              this.checkMenuIndex.push(0);
              if (this.detail.tags.data[i].menus.length > 0) {
                temp.id = this.detail.tags.data[i].menus[0].target_id;
                price = this.detail.tags.data[i].menus[0].fill_price;
                for (
                  var j = 0;
                  j < this.detail.tags.data[i].menus[0].perfer.length;
                  j++
                ) {
                  if (
                    this.detail.tags.data[i].menus[0].perfer[j].category.data
                      .length > 0
                  ) {
                    perfer.push(
                      this.detail.tags.data[i].menus[0].perfer[j].category
                        .data[0].id
                    );
                  }
                }
                this.fill_price.push(price);
              }
              this.perferResult.push(perfer);
              this.remarks.push("");
              this.menus_id.push(temp);
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    showTaste(index, key) {
      this.actIndex = index;
      this.actPerfer = this.detail.tags.data[index].menus[key].perfer;
      this.actRemark = this.remarks[index];
      this.childResult = this.perferResult[index];
      this.isTasteShow = true;
    },
    changeChildDish(index, id, key) {
      // 点击修改选择单品
      this.menus_id[index].id = id;
      this.$set(this.checkMenuIndex, index, key);
      this.fill_price[index] = this.detail.tags.data[index].menus[
        key
      ].fill_price;
    },
    changeResult(index, id) {
      this.$set(this.childResult, index, id);
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .dish_content .van-image {
  padding: 5px 10px 10px;
}
/deep/ .van-image img {
  border-radius: 6px;
  max-width: 25rem;
  margin: 0 auto;
}
.home {
  width: 100%;
  height: auto;
  background-color: #fff;
}
.noflex {
  border-radius: 8px;
  position: relative;
  left: -1px;
}
.dish_content {
  display: flex;
}
.dish_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}
.currentPrice {
  font-size: 20px;
  font-weight: 600;
  color: #fe2a00;
  /* color: #ff6666; */
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.info {
  width: 90%;
  margin-left: 5%;
  height: auto;
  position: relative;
}
.fontLine {
  padding-bottom: 10px;
  font-size: 14px;
}
.setPerfer {
  position: absolute;
  width: 35px;
  height: 35px;
  bottom: 10px;
  right: 0px;
}
.flexNone {
  flex: none;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  font-size: 18px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 34px;
  float: right;
  text-align: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
}
.total_price {
  height: 34px;
  line-height: 34px;
  font-size: 20px;
  text-indent: 10px;
}
.tasteGropu {
  width: 90%;
  margin-left: 5%;
  font-size: 16px;
  height: auto;
}
.tasteItem {
  width: 100%;
  height: auto;
  color: #222;
}
.tasteItemTitle {
  width: 100%;
  height: 45px;
  line-height: 45px;
}
.tasteItemRadio {
  /* width: 100%;
  height: 33px;
  line-height: 33px;
  text-indent: 10px;
  border: 1px solid #2f75f4; */
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 5px;
  margin-left: 10px;
  margin-bottom: 10px;
  color: #000;
}
.tasteItemRadio_act {
  background-color: #2f75f4;
  color: #fff;
}
.dishList {
  width: 100%;
  min-height: 5rem;
  max-height: 80vh;
  overflow-y: auto;
  font-size: 14px;
  margin-bottom: 50px;
}
.dishItem {
  width: 90%;
  margin-left: 5%;
  min-height: 80px;
}
.dishItem:last-child {
  padding-bottom: 7.5rem;
}
.dishTitle {
  width: 100%;
  height: 36px;
  line-height: 36px;
}
.dishChild {
  width: 100%;
  padding-bottom: 0.625rem;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  z-index: 1;
}
.childTitle {
  flex: auto;
  height: 42px;
  text-indent: 10px;
  width: 100px;
  display: flex;
  align-items: center;
}
.childTitle1 {
  width: 100%;
  height: 20px;
  line-height: 20px;
}
.selChild {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 2;
}
.actChild {
  border: 1px solid #2f75f4;
  border-radius: 3px;
}
.childImg {
  border: 1px solid #ddd;
  border-radius: 3px;
  overflow: hidden;
}
.van-button__text {
  color: #fff;
}
.icontext {
  position: absolute;
  font-size: 14px;
  right: 0px;
}
/*购物车样式*/
.cartDetail {
  width: 100%;
  height: auto;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
}
.cart_dish_name {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.son_dish {
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  padding-top: 10px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  clear: both;
}
.realPrice {
  color: #000;
}
.inDot {
  width: 24px;
  height: 24px;
  background: #ee0a24;
  border-radius: 50%;
  position: fixed;
  z-index: 2;
}
.tasteBtn {
  width: 50px;
  height: 32px;
  /* background:url('/static/img/Option.png'); */
  background-size: contain;
}
.tagsBox {
  display: flex;
  flex-wrap: wrap;
}
.dishChild_content {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 10px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/e_menu/PackageDetail.vue